import React, { useEffect } from 'react';
import { pxToRem } from '../util';
import ScrollingTable from './ScrollTable';
import CardHeader from './CardHeader';
import { toFixedNumber } from '@/utils/util';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const statitics = [
    {
      label: '重疾下降率',
      value: toFixedNumber(
        (props.charts?.recentThreeYearsDistribution
          ?.criticalIllnessDeclineRate || 0) * 100,
        2
      ),
      suffix: '%',
    },
    {
      label: '异常指标好转率',
      value: toFixedNumber(
        (props.charts?.recentThreeYearsDistribution
          ?.abnormalIndicatorImprovementRate || 0) * 100,
        2
      ),
      suffix: '%',
    },
    {
      label: '异常指标达标率',
      value: toFixedNumber(
        (props.charts?.recentThreeYearsDistribution
          ?.abnormalIndicatorComplianceRate || 0) * 100,
        2
      ),
      suffix: '%',
    },
  ];
  const columns = [
    {
      title: '异常指标',
      dataIndex: 'name',
      align: 'left',
      headerStyle: { width: '100px' },
    },
    {
      title: '管理总人数',
      dataIndex: 'total',
      align: 'center',
    },
    {
      title: '好转人数',
      dataIndex: 'improvementTotal',
      align: 'center',
    },
    {
      title: '达标人数',
      dataIndex: 'complianceTotal',
      align: 'center',
    },
  ];
  const [data, setData] = React.useState<any[]>([]);

  useEffect(() => {
    setData(props.charts?.abnormalIndicatorManagement || []);
  }, [props.charts]);

  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: `calc(57vh + 5px)`,
        maxHeight: `calc(57vh + 5px)`,
        overflow: 'hidden',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>健康管理效果</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          Health management tracking
        </span>
      </div> */}
      <CardHeader
        title="近3年健康管理效果"
        subtitle="Health management tracking"
      />

      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {statitics.map((item) => {
            return (
              <div
                key={item.label}
                style={{
                  backgroundColor: 'rgba(10, 115, 255, 0.12)',
                  width: '33%',
                  padding: pxToRem(6),
                  boxSizing: 'border-box',
                  marginTop: pxToRem(5),
                  textAlign: 'center',
                }}
              >
                <div style={{ fontSize: pxToRem(16), color: color }}>
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: pxToRem(24),
                    color: 'rgb(61, 171, 255)',
                    fontWeight: 500,
                  }}
                >
                  {item.value}
                  {item.suffix && (
                    <span
                      style={{ fontSize: pxToRem(14), marginLeft: pxToRem(2) }}
                    >
                      {item.suffix}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div>
          <ScrollingTable
            columns={columns}
            data={data}
            rowHeight={48}
            visibleRows={11}
            scrollInterval={2000} // 每1秒滚动一次
            style={{
              height: '45vh',
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default Box1;
